export default [
    {
        path: '/user',
        name: 'UserDashboard',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/Dashboard.vue')
    },
    {
        path: '/user/candidates',
        name: 'UserCandidates',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/Candidates.vue')
    },
    {
        path: '/user/sms-center',
        name: 'UserSmsCenter',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/SmsCenter.vue')
    },
    {
        path: '/user/call-center',
        name: 'UserCallCenter',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/CallCenter.vue')
    },
    {
        path: '/user/clients',
        name: 'UserClientCenter',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/auth/AddClients.vue')
    },
    {
        path: '/user/ussd-center',
        name: 'UserUssdCenter',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/UssdPollCenter.vue')
    },
    {
        path: '/user/top-ups',
        name: 'UserTopUps',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/TopUps.vue')
    },
    {
        path: '/user/change-password',
        name: 'UserChangePassword',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/auth/ChangePassword.vue')
    },
    {
        path: '/user/settings',
        name: 'UserSettings',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/Settings.vue')
    },
    {
        path: '/user/profile',
        name: 'UserProfile',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/Profile.vue')
    },
    {
        path: '/user/poll-results',
        name: 'UserResults',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/PollResults.vue')
    },
    {
        path: '/user/check-cost',
        name: 'UserCostChecker',
        component: () => import(/* webpackChunkName: "about" */ '../../views/admin/CostChecker.vue')
    },
]